import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigatorService {
  constructor(private router: Router) {}

  get baseUrl(): string {
    let baseUrl = window.location.origin;

    if (baseUrl.includes('://localhost')) {
      baseUrl = 'http://localhost:5005';
    }

    return baseUrl;
  }

  navigateToErrorPage(): void {
    this.router.navigate(['error']);
  }
}
